import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, TransitionGroup as _TransitionGroup, unref as _unref, withCtx as _withCtx, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "cp-favorite-tickets__slider-wrapper" }
const _hoisted_2 = {
  key: 0,
  class: "cp-favorite-tickets__buttons"
}

import { useKeenSlider } from "keen-slider/vue";
import { FavoriteTicket } from "../models/favorite-ticket";
import TicketPromoCard from "./ticket-promo-card.vue";
import DsButton from "@sazka/design-system/src/button/ds-button.vue";
import { useKeenSliderConfig } from "../composables/use-keen-slider-config";


export default /*@__PURE__*/_defineComponent({
  __name: 'favorite-tickets-slider',
  props: {
    favoriteTickets: {}
  },
  setup(__props: any) {



const { config, areButtonsVisible, isButtonLeftDisabled, isButtonRightDisabled } = useKeenSliderConfig();

const [container, slider] = useKeenSlider({ ...config });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      ref_key: "container",
      ref: container,
      class: "keen-slider cp-favorite-tickets__slider"
    }, [
      _createVNode(_TransitionGroup, {
        name: "slide",
        onAfterAppear: _cache[0] || (_cache[0] = ($event: any) => (_unref(slider).update())),
        onAfterEnter: _cache[1] || (_cache[1] = ($event: any) => (_unref(slider).update())),
        onAfterLeave: _cache[2] || (_cache[2] = ($event: any) => (_unref(slider).update()))
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.favoriteTickets, (ticket) => {
            return (_openBlock(), _createElementBlock("div", {
              key: ticket.externalSystemID,
              class: "keen-slider__slide cp-favorite-tickets__slide"
            }, [
              _createVNode(TicketPromoCard, { card: ticket }, null, 8, ["card"])
            ]))
          }), 128))
        ]),
        _: 1
      })
    ], 512),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (_unref(slider) && _unref(areButtonsVisible))
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(DsButton, {
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(slider).prev())),
                "is-disabled": _unref(isButtonLeftDisabled),
                size: "sm",
                class: "cp-favorite-tickets__button",
                "icon-left": "arrow-left",
                type: "interaction",
                "aria-label": "Předchozí slide"
              }, null, 8, ["is-disabled"]),
              _createVNode(DsButton, {
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(slider).next())),
                "is-disabled": _unref(isButtonRightDisabled),
                size: "sm",
                class: "cp-favorite-tickets__button",
                "icon-left": "arrow-right",
                type: "interaction",
                "aria-label": "Následujicí slide"
              }, null, 8, ["is-disabled"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})